

   $ = window.$ = window.jQuery = require('jquery');



    require('foundation-sites');

 




require('@fancyapps/fancybox/dist/jquery.fancybox');

require('../../node_modules/slick-carousel/slick/slick.min.js');
require('../../node_modules/jquery-bar-rating/dist/jquery.barrating.min.js');



require('../../node_modules/vanilla-fitvids/jquery.fitvids.js');

require('../../node_modules/jquery-match-height/dist/jquery.matchHeight-min.js');



//not on npm:
var BackgroundCheck = require('./libs/background-check.min.js'); 


var imagesLoaded = require('imagesloaded');


 
 
 var jQueryBridget = require('jquery-bridget');
var Isotope = require('isotope-layout');
// make Isotope a jQuery plugin
jQueryBridget( 'isotope', Isotope, $ );
 
// provide jQuery argument
imagesLoaded.makeJQueryPlugin( $ );

//Isotope.makeJQueryPlugin( $ );

require('Modernizr');




var iphone_breakpoint = 767;
var ipad_breakpoint = 1019;

var scroll_top = 0;

var win_height;
var win_width;
var new_height;

var $masonry_container = jQuery('.mason_grid');

(function($) {
	
	'use strict';
	
	
	
	
	// -- Opening in a new window without target _blank -- //
	$('a[rel="external"]').on("click", function(){
		window.open( $(this).attr('href') );
		return false;
	});
	
	function do_positioning(){
		win_height = jQuery( window ).height();
		win_width = jQuery( window ).width();
		//$('.focuspoint').focusPoint();
	}
		
	$(window).on( "resize", function( event ) { 
		do_positioning();	
	}); 
	
	$(document).on('facetwp-loaded', function() {
        if (FWP.loaded) {
            $('html, body').animate({
                scrollTop: $('.facetwp-template').offset().top
            }, 500);
        }
    });
	
	function page_init(){
		'use strict';
		$(document).foundation();
		
		
		do_positioning();
		$('.single').fitVids();
	    

		
		if($('#top_slider').length){
			
			$('#top_slider').on('init', function(event, slick){
			 	
					BackgroundCheck.init({
					  	targets: '#site-header',
				  		images: '.slick-active img',
				  		threshold:40
					});
				});

			    $('#top_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
				   BackgroundCheck.refresh();
				});
			
			    $('#top_slider').slick({
			        dots: true,
			        arrows:false,
			        autoplay:true,
			        accessibility:true,
			        infinite: true,
			        fade:true,
			        speed:1200,
			        pauseOnHover:false,
			        waitForAnimate:false,
			        nextArrow: '<span class="lnr lnr-chevron-right slide-arrow-right"></span>',
					prevArrow: '<span class="lnr lnr-chevron-left slide-arrow-left"></span>',
					
			    });
/*
			    $('#top_slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
				   BackgroundCheck.refresh();
				});
*/	
			 
			   
			    
		} //feature_slider
	    
		if($('.page_slideshow').length){
		    $('.page_slideshow').slick({
		        dots: false,
		        arrows:true,
		        autoplay:true,
		         adaptiveHeight: true,
		        accessibility:true,
		        fade:true,
		        speed:800,
		        pauseOnHover:false,
		        waitForAnimate:false,
		        nextArrow: '<span class="lnr lnr-chevron-right slide-arrow-right"></span>',
				prevArrow: '<span class="lnr lnr-chevron-left slide-arrow-left"></span>'
		    });
		}
	   
		if($('.work_top_slideshow').length){
			$('.work_top_slideshow').slick({
		        dots: false,
		        arrows:true,
		        autoplay:true,
		        // adaptiveHeight: true,
		        accessibility:true,
		        fade:true,
		        speed:800,
		        pauseOnHover:false,
		        waitForAnimate:false,
		        nextArrow: '<span class="lnr lnr-chevron-right slide-arrow-right"></span>',
				prevArrow: '<span class="lnr lnr-chevron-left slide-arrow-left"></span>'
	    	});
	    }
	    
	    
	    
	    
	    var $hamburger = $(".hamburger");
		$hamburger.on("click", function(e) {
			$hamburger.toggleClass("is-active");
		
		});
		
		var $jsoverlay = $(".js-off-canvas-overlay");
		$jsoverlay.on("click", function(e) {
			$hamburger.removeClass("is-active");
		});
		
		$('.wp-block-button a').addClass('button');
/*
		$('.is-style-checkbox li').matchHeight({
			//	byRow: false
			});
		
*/


		$masonry_container.imagesLoaded(function(){
			$masonry_container.isotope({
			resizable: false, // disable normal resizing
			itemSelector : '.mblock',
			animationEngine : 'best-available',
			gutterWidth: 20,
			// set columnWidth to a percentage of container width
			masonry: { 
			//columnWidth: set_mosaic_width($masonry_container.width())
			}
			}, function( $items ) {
			var id = this.attr('id'),
			len = $items.length;
			console.log( 'Isotope has filtered for ' + len + ' items in #' + id );
			});	  
		});
			
		
				
		
			
	} //end page_init
	
	
	page_init();
	
	
	
	
	$("[data-fancybox]").fancybox({
		afterShow: function( instance, slide ) {
			page_init();
		}
	});
	
		
/*
$(document).on(
'show.zf.dropdownmenu', function(ev, $el) {
//var dropdown = $(this).find('.is-dropdown-submenu');
var dropdown = $el;
dropdown.css('display', 'none');
dropdown.fadeIn('fast');
});
$(document).on(
'hide.zf.dropdownmenu', function(ev, $el) {
//var dropdown = $(this).find('.is-dropdown-submenu');
var dropdown = $el.children("ul");
dropdown.css('display', 'block');
dropdown.fadeOut('fast', function(){
});
});
*/
	
	function set_mosaic_width(containerWidth){
			//var masoncalcwidth = Math.floor(containerWidth / 3);
	    	
		    if(browserwidth >749){
	    		return containerWidth / 4;
	    	}
	    	else{
		    	return containerWidth;
	    	}
}
	


var prev = 0;
var $window = $(window);
var nav = $('#site-header');
var scrollTop = $window.scrollTop();
var adminoffset = 32;
if(!$('#wpadminbar').length){
	adminoffset = 0;
}
var baroffset = 0+adminoffset;

$window.on('scroll', function(){
  	scrollTop = $window.scrollTop();
  	//console.log(scrollTop);
  	if(scrollTop > prev && scrollTop > 5){ //going down
	  	 nav.addClass('is-stuck');
	}
	else if(scrollTop < nav.height()+adminoffset){
		nav.removeClass('is-stuck');
	}
	
	prev = scrollTop;
  
});
/*
var prev = 0;
var $window = $(window);
var nav = $('#site-header');
var scrollTop = $window.scrollTop();
var adminoffset = 32;
if(!$('#wpadminbar').length){
	adminoffset = 0;
}
var baroffset = 0+adminoffset;



$window.on('scroll', function(){
  scrollTop = $window.scrollTop();
  //console.log(scrollTop);
  if(scrollTop > prev){ //going down
	  if(scrollTop > nav.height()+adminoffset ){
		  if(!nav.hasClass('shownbar') && !nav.hasClass('animatingbar')){
		  		nav.css('top',(nav.height()*-1)+adminoffset );
		  }
		  else{
			  nav.addClass('animatingbar');
			  nav.animate({ 
		        'top': (nav.height()*-1)+adminoffset,
		    }, 500, function(){
			    nav.removeClass('shownbar');
			    nav.removeClass('animatingbar');
		    })
		  }
	  }
	  else{
		   if(!nav.hasClass('shownbar')){
		  		nav.css('top',(scrollTop*-1)+adminoffset );
		  }
	  }
  		
  }
  else{ //going up
	  if(scrollTop < nav.height()+adminoffset ){
		  nav.css('top',(scrollTop*-1)+adminoffset );
	  }
	  else{
		  if(!nav.hasClass('shownbar')){
		  	nav.addClass('shownbar');
		  	nav.animate({ 
		        'top': 0+adminoffset,
		    }, 500);
		    
		  }
	  }
  }
*/
  
  
//  && !nav.hasClass('hiddenbar')
/*
  if(scrollTop >baroffset){
  	nav.addClass('scrollhide-nav');
  	
  	if(scrollTop > prev){
	  	nav.addClass('hiddenbar');
	  	
	  //	nav.css('top',(scrollTop*-1)+adminoffset );
  	}
  	else{
	  	nav.removeClass('hiddenbar');
	  	//nav.css('top',0+adminoffset);
  	}
  	//nav.css('top',0);
  }
  else{
	  nav.removeClass('scrollhide-nav');
	  nav.removeClass('hiddenbar');
	 // nav.css('top',(scrollTop*-1)+adminoffset );
  }
*/
  
/*
  prev = scrollTop;
  
});
  
*/
  
	
	
})( jQuery );




 